export default {
  namespaced: true,
  state: {
    current: null,
  },
  getters: {
    savedSearches: (state, getters, rootState, rootGetters) => rootGetters['searcher/savedSearchesBySearcher']('content'),
  },
  actions: {
    async REFRESH({ dispatch }) {
      dispatch('searcher/FETCH_SAVED_SEARCHES', null, { root: true });
    },
    async NAVIGATE_TO({ commit, getters }, tag) {
      commit('SET_CURRENT', tag);
    },
  },
  mutations: {
    SET_CURRENT: (state, tag) => {
      state.current = tag;
    },
  },
};
